
export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initAnimation()
    })
  },
  methods: {
    initAnimation() {
      const gsap = this.$gsap

      const TL1 = gsap.timeline({
        scrollTrigger: {
          scrub: 0.5,
          start: '10% bottom',
          end: 'bottom bottom',
          trigger: '#sections-science',
        },
      })

      const TL2 = gsap.timeline({
        scrollTrigger: {
          start: 'top',
          end: 'bottom',
          trigger: '#sections-science',
        },
      })

      gsap.set('#science-bgimage', {
        scaleX: 1.08,
        scaleY: 1.08,
      })

      TL1.from('#science-bgimage', {
        y: '-=40',
        duration: 0.35,
        ease: 'Power3.easeInOut',
      })

      TL2.from('.markers', {
        alpha: 0,
        scaleX: 3,
        scaleY: 3,
        duration: 1,
        ease: 'Power3.easeInOut',
      })
    },
  },
}
